import React from "react";
import { Button, Grid, Typography, Stack } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Modal from "../../Components/Modal";
import { establishments } from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import { useSnackbar } from "notistack";

interface IRemoveEstablishmentProps {
  id: number;
  reloadResourceTable: () => void;
  close: () => void;
}

const RemoveEstablishment: React.FC<IRemoveEstablishmentProps> = ({ id, reloadResourceTable, close }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading, loading } = useGlobalContext();

  const handleClose = () => close();

  const handleRemove = async () => {
    if (!id) return;
    setLoading?.(true);

    const { message = "", status: statusCode = 500 } = await establishments.delete(String(id));


    setLoading?.(false);

    if (message) {
      const variant = (statusCode === 200 || statusCode === 204) ? "success" : "error";
      enqueueSnackbar(message || "Erro ao remover estabelecimento", { variant });
    }

    reloadResourceTable();
    close();
  };

  return (
    <Modal
      title="Remover estabelecimento"
      open={!loading}
      closeModal={handleClose}
      maxWidth="sm"
    >
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <Typography variant="body1">
            Tem certeza de que deseja remover este estabelecimento? 
            <br />
            <Typography component="span" fontWeight="bold" color="error">
              Esta ação é irreversível!
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button variant="outlined" onClick={handleClose} aria-label="Cancelar remoção">
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleRemove}
              startIcon={<DeleteForeverIcon />}
              aria-label="Confirmar remoção de estabelecimento"
            >
              Remover
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default RemoveEstablishment; 